import type { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import IconBuilding from '../../assets/icons/data/IconBuilding.svg'
import IconChurch from '../../assets/icons/data/IconChurch.svg'
import IconConstruction from '../../assets/icons/data/IconConstruction.svg'
import IconFactory from '../../assets/icons/data/IconFactory.svg'
import IconHandshake from '../../assets/icons/data/IconHandshake.svg'
import IconHouse from '../../assets/icons/data/IconHouse.svg'
import IconMap from '../../assets/icons/data/IconMap.svg'
import IconMarker from '../../assets/icons/data/IconMarker.svg'
import IconMarkerMap from '../../assets/icons/data/IconMarkerMap.svg'
import IconOffice from '../../assets/icons/data/IconOffice.svg'
import IconPark from '../../assets/icons/data/IconPark.svg'
import IconSkyscraper from '../../assets/icons/data/IconSkyscraper.svg'
import HouseStraight from '../../assets/icons/data/IconHouseStraight.svg'
import Catalog from '../../assets/icons/catalog/catalog.svg'

const IconWrapper = styled.span<{ height: number }>`
  height: 1.5rem;
  width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ height }) =>
    height &&
    css`
      width: ${height}rem !important;
      height: ${height}rem !important;
    `}
`

const IconHouseStraight = () => {
  return (
    <IconWrapper height={1.25}>
      <HouseStraight />
    </IconWrapper>
  )
}

const IconCatalog = () => {
  return (
    <IconWrapper height={1.75}>
      <Catalog />
    </IconWrapper>
  )
}

const ICONS: { [key: string]: ReactNode } = {
  adressen: <IconMarker />,
  adresseerbare_objecten: <IconMarker />,
  gebieden: <IconMap />,
  kadastrale_objecten: <IconBuilding />,
  kadastrale_subjecten: <IconOffice />,
  maatschappelijkeactiviteit: <IconHandshake />,
  meetbouten: <IconHouse />,
  monumenten: <IconChurch />,
  openbareruimte: <IconPark />,
  openbareruimte_id: <IconPark />,
  panden: <IconSkyscraper />,
  straten: <IconMarkerMap />,
  vestigingen: <IconFactory />,
  bouwdossiers: <IconConstruction />,
  postcodes: <IconHouseStraight />,
  map: <IconMap />,
  catalogus: <IconCatalog />,
}

export type DataIconType = keyof typeof ICONS

const DataIcon: FunctionComponent<{ type: DataIconType }> = ({ type }): ReactNode => {
  return ICONS[type]
}

export default DataIcon
